import { Provider } from '../';

export default function DebuggerProvider(devtools) {
  return Provider({
    send: function send(debuggerData) {
      devtools.sendExecutionData(debuggerData, this.context.execution, this.context.functionDetails, this.context.props);
    },
    wrapProvider: function wrapProvider(name, provider) {
      var _this = this;

      return Object.keys(provider).reduce(function (wrappedProvider, key) {
        var originalFunc = provider[key];

        wrappedProvider[key] = function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this.context.debugger.send({
            method: name + '.' + key,
            args: args
          });

          console.log(provider.context);
          return originalFunc.apply(provider, args);
        };

        return wrappedProvider;
      }, {});
    }
  }, {
    wrap: false
  });
}
//# sourceMappingURL=Debugger.js.map